import React from "react";
import Icon from "../../../ui/icons/Icon";
import iconsList from "../../../ui/icons/iconsList";
import classes from "./AddToolListItem.module.css";

const AddToolListItem = ({ onClick, accessibilityDescription, className }) => {

    const handleKeyDown = (event) => {
        if (!onClick)
            return;
        if (event.key === "Enter" || event.key === " ") {
            event.preventDefault();
            onClick(event);
        }
    };

    return (
        <div
            className={`${classes.AddToolListItem} ${className ?? ""}`}
            onClick={onClick}
            onKeyDown={handleKeyDown}
            role={onClick ? "button" : undefined}
            tabIndex={onClick ? 0 : undefined}
            aria-label={accessibilityDescription}
        >
            <Icon name={iconsList.plusCircle} size={39} className={classes.Icon} />
        </div>
    );
};

export default AddToolListItem;
